export default __webpack_public_path__ + "static/media/vector1.2bb8737f.gif";